import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
    fonts: {
        customBody: "Poppins",
    },
    colors: {
        switch: {
            500: '#70B259',
            600: '#64a04f',
        }
    },

    btn1: {
           500: '#AEB4B7'
        },

    btn2: {
        500: '#f6e58d'
    },

    btn3: {
        500: '#fa983a'
    },
    
    components: {
        FormLabel: {
            variants: {
                custom: {
                    fontWeight: '600',
                    fontSize: '18px',
                    color: '#666666',
                }
            }
        },

        Text: {
            variants: {
                custom: {
                    textTransform: 'uppercase',
                    fontWeight: '700',
                    fontSize: '14px',
                    color: '#798599',
                }
            }
        }
    }
})
export default theme